import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import FieldWrapper from "../FieldWrapper";
import {
    composeValidators,
    regRequiredValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import RadioGroupWrapper from "../../../HTMLEntities/RadioGroupWrapper";
import {WithTitleField} from "../Styled";
import {
    UserPassport,
    UserPassportSelectedValue,
} from "../../../../containers/RegistrationLoginPage/types";

const Passport: React.FC = () => {
    const passport = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.signUpPageData?.fields?.passport,
    );

    return useMemo(() => {
        if (passport) {
            const {visible, loading} = passport;
            console.log("loading11111111", loading);

            return (
                <>
                    <FieldWrapper visible={visible}>
                        <span />
                    </FieldWrapper>
                    <FieldWrapper visible={visible} loading={loading} loaderType="Radio Button">
                        <WithTitleField>
                            <strong>Do you have a valid passport?</strong>
                            <RadioGroupWrapper<UserPassport, UserPassportSelectedValue>
                                fieldData={passport}
                                validate={composeValidators(
                                    regRequiredValidate("Please select passport"),
                                )}
                            />
                        </WithTitleField>
                    </FieldWrapper>
                </>
            );
        }
        return null;
    }, [passport]);
};

export default Passport;
